import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

const dataManagement: AppRouteModule = {
  path: '/',
  name: '',
  component: LAYOUT,
  meta: {
    icon: '',
    title: t('routes.nurse.dataManagement'),
    hideMenu: true,
  },
  children: [
    {
      path: 'data-management',
      name: 'DataManagement',
      component: () => import('/@/views/nurse/data-management/index.vue'),
      meta: {
        icon: '',
        title: t('routes.nurse.dataManagement'),
      },
    },
  ],
};

export default dataManagement;
